module.exports = __webpack_public_path__ + "static/img/cooling-capacity.57aebd2b.png";